import React from 'react';
import Text from '../../../Text';
import { dataHooks } from '../../Notification.constants';
import { classes } from '../../Notification.st.css';
import { TextLabelProps } from '../../Notification.types';

const TextLabel = ({
  ellipsis = true,
  placement = 'bottom',
  children,
  ...propsWithNoDefaults
}: TextLabelProps) => (
  <div className={classes.label}>
    <Text
      weight="normal"
      {...{
        ellipsis,
        placement,
        ...propsWithNoDefaults,
      }}
      light
      dataHook={dataHooks.notificationLabel}
    >
      {children}
    </Text>
  </div>
);

TextLabel.displayName = 'Notification.TextLabel';

export default TextLabel;
